/* ==========================================================
   Video Carousel — assets/section-video-carousel.js
   - Initializes Slick: N slides desktop, 1.5 slides mobile (peek)
   - Click-to-play per slide (Shopify upload / YouTube / Vimeo)
   - Only one video plays at a time across the whole carousel
   ========================================================== */

(function () {
  function initVideoCarousel(root) {
    if (!root || typeof jQuery === 'undefined') return;
    var $root = jQuery(root);
    var slidesDesktop = parseInt($root.data('slides-desktop'), 10) || 5;

    if ($root.hasClass('slick-initialized')) {
      $root.slick('unslick');
    }

    $root.slick({
      slidesToShow: slidesDesktop,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      speed: 500,
      variableWidth: false,
      prevArrow: '<button type="button" class="vc-arrow vc-arrow--prev flip-x" aria-label="Previous"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"></path></svg></button>',
      nextArrow: '<button type="button" class="vc-arrow vc-arrow--next" aria-label="Next"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1561,
          settings: {
            slidesToShow: 3.2,
            arrows: true,
            centerMode: false
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2.2,
            arrows: true,
            centerMode: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.2,
            arrows: true,
            centerMode: false
          }
        }
      ]
    });

    setupPlayButtons(root);

    // Pause/stop any playing video when the slide changes
    $root.on('beforeChange', function () {
      stopAllVideos(root);
    });
  }

  function setupPlayButtons(root) {
    var slides = root.querySelectorAll('.video-slide');

    slides.forEach(function (slide) {
      var playBtn = slide.querySelector('.video-slide__play-btn');
      var posterWrap = slide.querySelector('.video-slide__poster-wrap');

      if (!playBtn) return;

      var handlePlay = function (e) {
        e.preventDefault();
        e.stopPropagation();
        playSlide(root, slide);
      };

      playBtn.addEventListener('click', handlePlay);
      // Also allow clicking the poster image itself to play
      if (posterWrap) {
        posterWrap.addEventListener('click', function (e) {
          if (slide.classList.contains('video-slide--playing')) return;
          handlePlay(e);
        });
      }
    });
  }

  function playSlide(root, slide) {
    // Stop every other playing video first — only one plays at a time
    stopAllVideos(root, slide);

    var player = slide.querySelector('.video-slide__player');
    var videoType = slide.dataset.videoType;
    var videoId = slide.dataset.videoId;

    if (!player || !videoId) return;

    // If already built, just show it (covers replay after stop)
    if (player.dataset.built === 'true') {
      slide.classList.add('video-slide--playing');
      restartPlayback(player, videoType);
      return;
    }

    if (videoType === 'youtube') {
      player.innerHTML =
        '<iframe src="https://www.youtube.com/embed/' + videoId +
        '?autoplay=1&mute=1&playsinline=1&rel=0" ' +
        'allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    } else if (videoType === 'vimeo') {
      player.innerHTML =
        '<iframe src="https://player.vimeo.com/video/' + videoId +
        '?autoplay=1&muted=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    } else if (videoType === 'shopify') {
      var template = slide.querySelector('.video-slide__video-template');
      if (template) {
        player.innerHTML = '';
        player.appendChild(template.content.cloneNode(true));
        var videoEl = player.querySelector('video');
        if (videoEl) {
          // Autoplay muted — browsers reliably allow muted autoplay,
          // whereas unmuted autoplay is blocked in most cases, which
          // was causing the previous unmuted-first attempt to fail/flicker.
          videoEl.muted = true;
          videoEl.setAttribute('muted', ''); // belt-and-suspenders for some mobile browsers
          videoEl.playsInline = true;
          videoEl.setAttribute('playsinline', '');
          videoEl.play().catch(function () {
            // no-op: if it still fails, the user can hit play manually
          });
        }
      }
    }

    player.dataset.built = 'true';
    slide.classList.add('video-slide--playing');
  }

  function restartPlayback(player, videoType) {
    if (videoType === 'shopify') {
      var videoEl = player.querySelector('video');
      if (videoEl) {
        videoEl.muted = true;
        videoEl.currentTime = 0;
        videoEl.play().catch(function () {});
      }
    } else {
      // For iframe embeds (YouTube/Vimeo), rebuild the iframe src to restart with autoplay
      var iframe = player.querySelector('iframe');
      if (iframe) {
        iframe.src = iframe.src; // reload triggers autoplay param again
      }
    }
  }

  function stopAllVideos(root, exceptSlide) {
    var playingSlides = root.querySelectorAll('.video-slide--playing');

    playingSlides.forEach(function (slide) {
      if (slide === exceptSlide) return;

      slide.classList.remove('video-slide--playing');

      var player = slide.querySelector('.video-slide__player');
      if (!player) return;

      var videoEl = player.querySelector('video');
      var iframe = player.querySelector('iframe');

      if (videoEl) {
        videoEl.pause();
      }
      if (iframe) {
        // Clearing src fully stops YouTube/Vimeo playback (including audio)
        iframe.src = '';
        player.dataset.built = 'false';
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.video-carousel').forEach(initVideoCarousel);
  }

  function whenReady(callback) {
    var attempts = 0;
    var maxAttempts = 100;

    function check() {
      attempts++;
      var jqueryReady = typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined';
      if (jqueryReady) {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(check, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', check);
    } else {
      check();
    }
  }

  whenReady(initAll);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var carousel = event.target.querySelector('.video-carousel');
      if (carousel) initVideoCarousel(carousel);
    });
  }
})();